import user from '@/api/user';
import router from '../router';

const state = {
    idToken: null,
    userId: null,
    user: '',
    auth: JSON.parse(localStorage.getItem('user')),
};

const getters = {
    balance: (state) => state.tariffList,
};

const actions = {
    signUserUp(context, payload) {
        user.create(payload)
            .then((response) => {
                const user = {
                    id: user.uid,
                };
                context.commit('SET_USER', user);
                alert('Регистрация прошла успешно!');

                context.dispatch('setLogoutTimer', response.data.expiresIn);
            })
            .catch((error) => {
                console.log(error);
            });
    },

    signUserIn(context, payload) {
        user.signin(payload)
            .then((response) => {
                localStorage.setItem('user', JSON.stringify(response.body));
            })
            .then(() => {
                // router.replace("/balance"), console.log("step2");
                router.push('/dispatcher');
            })
            .catch((error) => {
                this.$emit('onError', {
                    message: error.body.message,
                });
            });
    },

    tryAutoLogin({ commit }) {
        const token = localStorage.getItem('token');
        if (!token) {
            return;
        }
        const expirationDate = localStorage.getItem('expirationDate');
        const now = new Date();
        if (now >= expirationDate) {
            return;
        }
        const userId = localStorage.getItem('userId');
        commit('AUTH_USER', {
            token: token,
            userId: userId,
        });
    },

    setLogoutTimer({ commit }, expirationTime) {
        setTimeout(() => {
            commit('CLEAR_AUT_DATA');
        }, expirationTime * 1000);
        router.replace('/');
    },

    logout() {
        localStorage.removeItem('user');
        router.replace('/');
    },

    getUser: (context) => {
        user.fetchUser()
            .then((response) => {})

            .catch((reject) => {
                console.log(reject);
            });
    },
};

const mutations = {
    SET_USER(state, payload) {
        state.user = payload;
    },

    AUTH_USER(state, userData) {
        state.idToken = userData.token;

        state.userId = userData.userId;
    },

    CLEAR_AUT_DATA(state) {
        state.idToken = null;
        state.userId = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
